import Vue from 'vue'
import AlaoUi from '@alao-frontend/ui'
import { notify } from '~/components/AlaoNotification'
Vue.use(AlaoUi)
Vue.prototype.$notify = notify
Vue.notify = notify
